export const PisosERevestimentosIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3475 16.875H4.6525C3.80833 16.875 3.125 16.1908 3.125 15.3475V4.6525C3.125 3.80833 3.80917 3.125 4.6525 3.125H15.3467C16.1908 3.125 16.8742 3.80917 16.8742 4.6525V15.3467C16.875 16.1908 16.1908 16.875 15.3475 16.875Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
